import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseFectch';
import { Notification } from '../../types/notification';

export const notificationApi = createApi({
  reducerPath: 'notification',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Notifications'],
  endpoints: (builder) => ({
    getNotifications: builder.query<
      { notifications: Notification[]; log: string; status: string },
      void
    >({
      query: () => ({
        url: '/notifications',
        method: 'GET',
      }),
      providesTags: ['Notifications'],
    }),
    getUnreadCount: builder.query<{ unreadCount: number }, void>({
      query: () => ({
        url: '/notifications/unread-count',
        method: 'GET',
      }),
      providesTags: ['Notifications'],
    }),
    markAsRead: builder.mutation<Notification, string>({
      query: (notificationId) => ({
        url: `/notifications/${notificationId}/read`,
        method: 'POST',
      }),
      invalidatesTags: ['Notifications'],
    }),

    markAllAsRead: builder.mutation<{ modifiedCount: number }, void>({
      query: () => ({
        url: '/notifications/mark-all-read',
        method: 'POST',
      }),
      invalidatesTags: ['Notifications'],
    }),

    // Send notification to a user
    sendNotification: builder.mutation<
      any,
      {
        userId: string;
        type: string;
        companyId: string;
        message: string;
        meta?: any;
        isAdmin: boolean;
      }
    >({
      query: (notificationData) => ({
        url: '/notifications',
        method: 'POST',
        body: notificationData,
      }),
      invalidatesTags: ['Notifications'],
    }),

    // Send notification to multiple users
    sendBulkNotifications: builder.mutation<
      any,
      {
        userIds: string[];
        type: string;
        message: string;
        meta?: any;
      }
    >({
      query: (notificationData) => ({
        url: '/notifications/bulk',
        method: 'POST',
        body: notificationData,
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useSendNotificationMutation,
  useSendBulkNotificationsMutation,
} = notificationApi;
